module.exports = __webpack_public_path__ + "static/img/fk.1c724f0a.svg";